module.exports = __webpack_public_path__ + "img/travelService-ganbo-router.d9b6d955.png";